import { z } from "zod";
import { isValidCuit, normalizeCuit } from "./fiscal/cuit.js";
export const companyPersonSchema = z.object({
    cuit: z
        .string()
        .transform((value) => normalizeCuit(value))
        .refine(isValidCuit, "El CUIT no es válido: revisá el dígito verificador."),
    name: z.string().trim().min(1, "Falta el nombre.").max(200),
});
export const companyPersonUpdateSchema = companyPersonSchema.pick({ name: true });
/** The confirmation of an import: the same file, with the hash its preview returned. */
export const paymentPlanConfirmSchema = z.object({
    fileHash: z.string().regex(/^[0-9a-f]{64}$/, "Falta confirmar la vista previa."),
});
/** The cuotas to report, by number (0 is the pago a cuenta); the rest are left out. */
export const paymentPlanSelectionSchema = z.object({
    included: z.array(z.number().int().min(0)).max(1000),
});
/** Plans in one «fondos por mes» report, at most this many columns. */
export const PAYMENT_PLAN_FUNDS_MAX = 8;
export const paymentPlanFundsSchema = z.object({
    planIds: z
        .array(z.string().uuid())
        .min(1, "Elegí al menos un plan.")
        .max(PAYMENT_PLAN_FUNDS_MAX, `Se suman hasta ${PAYMENT_PLAN_FUNDS_MAX} planes por informe.`),
});
export const paymentPlanOmitMonthSchema = paymentPlanFundsSchema.extend({
    month: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, "El mes tiene que ser AAAA-MM."),
});
export const paymentPlanIndividualSchema = z.object({
    /** Both due dates side by side; they are alternatives, never added. */
    both: z.boolean().default(false),
});
/**
 * «Cómo leer el plan», as Maxi's approved report says it. They go to the client in the PDF; the
 * wording is the studio's to validate.
 */
export const PAYMENT_PLAN_EXPLANATIONS = [
    { title: "Capital", body: "Parte del importe consolidado que se devuelve en cada cuota." },
    {
        title: "Interés financiero",
        body: "Costo de financiar el capital mediante el plan de pagos.",
    },
    {
        title: "Interés resarcitorio",
        body: "Importe adicional que indica ARCA para ese vencimiento.",
    },
    {
        title: "Total a pagar",
        body: "Capital más intereses de cada cuota. Primer y segundo vencimiento son alternativas: no se suman.",
    },
];
//# sourceMappingURL=payment-plans.js.map